import { queryClient, QueryClientProvider } from "@/queryClient";
import router from "@/routes";
import "@/styles/styles.css";
import { AWSCognitoProvider as AuthProvider } from "@/modules/common/context/auth/auth.context";
import WithAxios from "@/modules/common/components/wrappers/with-axios";
import { useEffect, useState } from "react";
import { FeatureContext } from "@/modules/common/components/layout/side-menu/old-navbar/feature.context";
import { FeatureProvider } from "@/modules/common/components/layout/side-menu/old-navbar/feature-provider";
import { createPortal } from "react-dom";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/quill/dist/quill.snow.css";
import NawyPassportProvider from "@/modules/common/context/nawy-passport.provider";
import FeatureFlagsProvider from "@/modules/common/context/feature-flags.provider";
import { OrganizationProvider } from "@/modules/common/context/organizations/get-user-organizations.provider";
import useLocalStorageState from "@/modules/common/hooks/local-storage.hook";
import { AnalyticsProvider } from "@/modules/analytics/context/analytics.context";

function App() {
  const [configs, setConfigs] = useState(null);
  const value = { configs, setConfigs };

  const [clearLocalStorage, setClearLocalStorage] = useLocalStorageState(
    "clearLocalStorage",
    true
  );

  useEffect(() => {
    if (clearLocalStorage) {
      localStorage.clear();
      setClearLocalStorage(false);
    }
  }, [clearLocalStorage]);

  return (
    <FeatureContext.Provider value={value}>
      <FeatureProvider />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <OrganizationProvider>
            <AnalyticsProvider>
              <NawyPassportProvider>
                <FeatureFlagsProvider>
                  <WithAxios>
                    <RouterProvider router={router} />
                  </WithAxios>
                </FeatureFlagsProvider>
              </NawyPassportProvider>
            </AnalyticsProvider>
          </OrganizationProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
      {createPortal(<ToastContainer stacked={false} />, document.body)}
    </FeatureContext.Provider>
  );
}

export default App;
